import { db } from '../db';

function distinctCount(docData, metric) {
  const ids = docData[`${metric}Ids`];
  if (ids && typeof ids === 'object') return Object.keys(ids).length;
  return docData[metric] || 0;
}

export async function fetchGraphData(startDate, endDate) {
  const statsCollection = db.collection("Stats");
  const startDateObj = new Date(startDate);
  const endDateObj = new Date(endDate);
  endDateObj.setHours(23, 59, 59, 999);

  const labels = [];
  const devDauData = [];
  const devNewData = [];
  const testerNewData = [];
  const testerDauData = [];
  const totalDauData = [];
  const totalNewAccData = [];

  for (let date = startDateObj; date <= endDateObj; date.setDate(date.getDate() + 1)) {
    const dateString = date.toISOString().split('T')[0];
    labels.push(dateString);
    
    /*devDauData.push(0);
    devNewData.push(0);
    testerNewData.push(0);
    testerDauData.push(0);
    totalDauData.push(0);
    totalNewAccData.push(0);*/
    try {
      const docSnapshot = await statsCollection.doc(dateString).get();
      if (docSnapshot.exists) {
        const docData = docSnapshot.data();

        const devDau = distinctCount(docData, 'devDau');
        const devNew = distinctCount(docData, 'devNew');
        const testerNew = distinctCount(docData, 'testerNew');
        const testerDau = distinctCount(docData, 'testerDau');

        // Populate individual metrics
        devDauData.push(devDau);
        devNewData.push(devNew);
        testerNewData.push(testerNew);
        testerDauData.push(testerDau);

        // Calculate totals
        const totalDau = devDau + testerDau;
        const totalNewAcc = devNew + testerNew;

        totalDauData.push(totalDau);
        totalNewAccData.push(totalNewAcc);
      } else {
        // If no data is available for the day, add 0 for all metrics
        devDauData.push(0);
        devNewData.push(0);
        testerNewData.push(0);
        testerDauData.push(0);
        totalDauData.push(0);
        totalNewAccData.push(0);
      }
    } catch (error) {
      console.error("Error fetching document:", error);
      devDauData.push(0);
      devNewData.push(0);
      testerNewData.push(0);
      testerDauData.push(0);
      totalDauData.push(0);
      totalNewAccData.push(0);
    }
  }

  return { labels, devDauData, devNewData, testerNewData, testerDauData, totalDauData, totalNewAccData };
}



// WEBPACK FOOTER //
// ./src/Firestore/Graph.js